<template>
	<div class="search-bar-wrap">
		<input type="text" :autocomplete="autocomplete" class="search-bar" :value="displayValue" name="search" :placeholder="$t('search')" @input="onInput" />
	</div>
</template>

<script>
export default {
	name: 'SearchBar',
	props: {
		value: {
			type: [String, Number],
			default: ''
		},
		autocomplete: {
			type: String,
			default: 'off'
		}
	},
	computed: {
		displayValue() {
			return this.value == null ? '' : String(this.value)
		}
	},
	methods: {
		onInput(event) {
			this.$emit('input', event.target.value);
		}
	}
}
</script>

<style lang="scss" scoped>
@use '@/styles/vars.scss' as *;
.search-bar-wrap {
	width: 100%;
	box-sizing: border-box;
	position: sticky;
	top: 0;
	z-index: 20;
	background-color: $white;
}
.search-bar {
	display: block;
	width: 100% !important;
	max-width: 100% !important;
	box-sizing: border-box;
	min-height: 40px;
	border: 0.1px solid var(--md-theme-default-primary-on-background, #448aff);
	padding: 4px 16px;
	font-size: 100%;
	border-radius: 2px;
	background-color: $white;
}
</style>
